"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldInstantRouter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newInstantRouter",
                type: "address",
            },
        ],
        name: "NewInstantRouter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldLockers",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newLockers",
                type: "address",
            },
        ],
        name: "NewLockers",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProtocolPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProtocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewProtocolPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRelay",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRelay",
                type: "address",
            },
        ],
        name: "NewRelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTeleBTC",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTeleBTC",
                type: "address",
            },
        ],
        name: "NewTeleBTC",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldThirdPartyAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newThirdPartyAddress",
                type: "address",
            },
        ],
        name: "NewThirdPartyAddress",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldThirdPartyFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newThirdPartyFee",
                type: "uint256",
            },
        ],
        name: "NewThirdPartyFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTreasury",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTreasury",
                type: "address",
            },
        ],
        name: "NewTreasury",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "bitcoinTxId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "teleporter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[2]",
                name: "amounts",
                type: "uint256[2]",
            },
            {
                indexed: false,
                internalType: "uint256[4]",
                name: "fees",
                type: "uint256[4]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
        ],
        name: "NewWrap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "appId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "ccTransferRequests",
        outputs: [
            {
                internalType: "uint256",
                name: "inputAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipientAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "speed",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isUsed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_appId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
            {
                internalType: "address",
                name: "_lockers",
                type: "address",
            },
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "instantRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_txId",
                type: "bytes32",
            },
        ],
        name: "isRequestUsed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relay",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_instantRouter",
                type: "address",
            },
        ],
        name: "setInstantRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockers",
                type: "address",
            },
        ],
        name: "setLockers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "setProtocolPercentageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
        ],
        name: "setRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
        ],
        name: "setStartingBlockNumber",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
        ],
        name: "setTeleBTC",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_thirdPartyAddress",
                type: "address",
            },
        ],
        name: "setThirdPartyAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_thirdPartyFee",
                type: "uint256",
            },
        ],
        name: "setThirdPartyFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "startingBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "teleBTC",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "thirdParty",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdPartyAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdPartyFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes4",
                        name: "version",
                        type: "bytes4",
                    },
                    {
                        internalType: "bytes",
                        name: "vin",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "vout",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes4",
                        name: "locktime",
                        type: "bytes4",
                    },
                    {
                        internalType: "uint256",
                        name: "blockNumber",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "intermediateNodes",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICcTransferRouter.TxAndProof",
                name: "_txAndProof",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
        ],
        name: "wrap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
//# sourceMappingURL=CCTransferRouter.js.map